import {SHOW_CONFIRM, HIDE_CONFIRM} from './'

export function showConfirm(options) {
  return {
    type: SHOW_CONFIRM,
    confirmProps: options
  }
}
export function closeConfirm() {
  return {
    type: HIDE_CONFIRM
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/ui/confirm/actions.js